// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"fc075935d80045b0","8052":"e339b1744d044334","9024":"cd6e96e2e31ad85a"}[chunkId] + ".css";
};